module.exports = __webpack_public_path__ + "img/info_en.572cc3f7.png";